import { withHandlers, compose } from 'recompose'
import registerReduxModal from 'components/common/hoc/registerReduxModal'
import { ACTION_CONFIRMATION_MODAL } from '../constants'
import ActionConfirmationModal from './ActionConfirmationModal'

export default compose(
  registerReduxModal({ name: ACTION_CONFIRMATION_MODAL }),
  withHandlers({
    handleCancel: ({ onCancel, handleHide }) => () => {
      handleHide()
      onCancel()
    },
    handleUpdate: ({ onUpdate, handleHide }) => () => {
      handleHide()
      onUpdate()
    }
  })
)(ActionConfirmationModal)
